import CryptoJS from "crypto-js";

function deriveKey(): CryptoJS.lib.WordArray {
  const decoded = CryptoJS.enc.Base64.parse(process.env.REACT_APP_ENCRYPTION_KEY || "");
  return CryptoJS.SHA256(decoded);
}

export function encryptClientSecret(plainText: string): string {
  try{
  const key = deriveKey();
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const combined = iv.clone().concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
}
catch(error: any){
return plainText;
}
}

export function decryptClientSecret(cipherBase64: string): string {
  try{
  const key = deriveKey();
  const cipherData = CryptoJS.enc.Base64.parse(cipherBase64);
  const iv = CryptoJS.lib.WordArray.create(cipherData.words.slice(0, 4), 16);
  const ciphertext = CryptoJS.lib.WordArray.create(
    cipherData.words.slice(4),
    cipherData.sigBytes - 16
  );
  const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });
  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypted);
}
catch (error: any){
return cipherBase64;
}
}
